import { CommentTagPipe } from './comment-tag.pipe'
import { ConvertCurrencyPipe } from '@shared/pipe/convertCurrency.pipe'
import { DateFormatPipe } from './dateFormat.pipe'
import { FilterCurrenciesPipe } from '@shared/pipe/filter-currencies.pipe'
import { FilterPipe } from './filter.pipe'
import { FormatHoursPipe } from '@shared/pipe/formatHours.pipe'
import { GetMenuItemNamePipe } from './menuItemName.pipe'
import { LangPipe } from './lang.pipe'
import { LangfPipe } from './langf.pipe'
import { NgModule } from '@angular/core'
import { OrderByPipe } from '@shared/pipe/orderBy.pipe'
import { ReviewStatusClassPipe } from './review-status-cell.pipe'
import { SafePipe } from './safe.pipe'
import { UrlStaticMediaPipe } from './url-staticmedia.pipe'
import { UserToChipArrayPipe } from './user-to-chip.pipe'

const pipes = [
  UrlStaticMediaPipe,
  LangPipe,
  LangfPipe,
  SafePipe,
  DateFormatPipe,
  GetMenuItemNamePipe,
  OrderByPipe,
  UserToChipArrayPipe,
  CommentTagPipe,
  ReviewStatusClassPipe,
  FormatHoursPipe,
  FilterCurrenciesPipe,
  ConvertCurrencyPipe,
  FilterPipe,
]

@NgModule({ declarations: pipes, exports: pipes })
export class PipesModule {}
